/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addnewlistingforyourbusiness5Inputs */

const en_addnewlistingforyourbusiness5 = /** @type {(inputs: Addnewlistingforyourbusiness5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a new listing for your business`)
};

const de_addnewlistingforyourbusiness5 = /** @type {(inputs: Addnewlistingforyourbusiness5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füg einen neuen Ort für dein Unternehmen hinzu.`)
};

/**
* | output |
* | --- |
* | "Add a new listing for your business" |
*
* @param {Addnewlistingforyourbusiness5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const addnewlistingforyourbusiness5 = /** @type {((inputs?: Addnewlistingforyourbusiness5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addnewlistingforyourbusiness5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addnewlistingforyourbusiness5(inputs)
	return de_addnewlistingforyourbusiness5(inputs)
});
export { addnewlistingforyourbusiness5 as "addNewListingForYourBusiness" }